import styled, { css, keyframes } from 'styled-components';
import { isTransitionAndAnimationsDisabled } from '../selenium/seleniumFeatures';
const config = {
  slidePx: 16,
  animationTime: 0.4,
  refreshTime: 0.2,
  animationDelay: 0.4,
  startOpacity: 0,
  disabled: isTransitionAndAnimationsDisabled()
};
const appear = keyframes(["0%{transform:translateX(", "px);opacity:0;}100%{transform:translateX(0);opacity:1;}"], config.slidePx);
const animationCss = css(["animation:", " ", "s cubic-bezier(0.42,0,0.58,1);animation-delay:", "s;animation-fill-mode:forwards;"], appear, config.animationTime, config.animationDelay);
const refreshAnimationCss = css(["animation:", " ", "s cubic-bezier(0.42,0,0.58,1);animation-fill-mode:forwards;"], appear, config.refreshTime);
export const AnimatedMessaging = config.disabled ? styled.div.withConfig({
  displayName: "MessagingAnimations__AnimatedMessaging",
  componentId: "sc-9sw8al-0"
})([""]) : styled.div.withConfig({
  displayName: "MessagingAnimations__AnimatedMessaging",
  componentId: "sc-9sw8al-1"
})(["transition:all;opacity:0;", ""], props => {
  if (props.loaded) {
    if (!props.delay) {
      return refreshAnimationCss;
    }

    return animationCss;
  }

  return '';
});